import React from "react";
import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";

const testimonials = [
  {
    quote:
      "Working with ELEV8FIT was a game-changer for our brand. The content quality exceeded our expectations and delivered a 3.2x return on our investment.",
    name: "Sarah Chen",
    title: "Marketing Director, Gymshark",
    rating: 5,
  },
  {
    quote:
      "The level of professionalism and audience engagement is unmatched. Our campaign reached over 2 million people with an engagement rate that blew our benchmarks out of the water.",
    name: "Marcus Williams",
    title: "Brand Partnerships, Nike",
    rating: 5,
  },
  {
    quote:
      "From concept to delivery, the entire process was seamless. The authentic connection with the fitness community drove real conversions for our product launch.",
    name: "Elena Rodriguez",
    title: "CMO, MyProtein",
    rating: 5,
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.15 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#121212] relative"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16"
        >
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#FF3B30] mb-4">
            Testimonials
          </p>
          <h2
            data-testid="testimonials-heading"
            className="font-['Barlow_Condensed'] text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white"
          >
            What Brands Say
          </h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              variants={itemVariants}
              data-testid={`testimonial-card-${i}`}
              className="bg-[#1A1A1A] border border-white/10 rounded-xl p-8 hover:-translate-y-1 hover:border-white/30 transition-all duration-300 flex flex-col"
            >
              <Quotes
                size={32}
                weight="fill"
                className="text-[#FF3B30]/30 mb-6"
              />

              <p className="text-base text-white/70 leading-relaxed flex-grow mb-8">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <Star
                    key={si}
                    size={16}
                    weight="fill"
                    className="text-[#FF3B30]"
                  />
                ))}
              </div>

              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#FF3B30]/20 flex items-center justify-center">
                  <span className="font-['Barlow_Condensed'] text-sm font-bold text-[#FF3B30]">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-bold text-white">{t.name}</p>
                  <p className="text-xs text-white/40">{t.title}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
